export const batteryImages: Record<number, string> = {
  0: '/images/logo_svg_battery_0_webapp.png',
  20: '/images/logo_svg_battery_20_webapp.png',
  40: '/images/logo_svg_battery_40_webapp.png',
  60: '/images/logo_svg_battery_60_webapp.png',
  80: '/images/logo_svg_battery_80_webapp.png',
  100: '/images/logo_svg_battery_100_webapp.png',
};
